import { Layer, Page, PageFace } from 'ui/components'

import { CRBTable, Filter } from './components'
import { CrbMonitorListContextProvider } from './context'

export default () => (
  <CrbMonitorListContextProvider>
    <Page title="CRB Monitor" face={PageFace.PRIMARY}>
      <Layer rounded shadowed stretch>
        <Filter />
        <CRBTable />
      </Layer>
    </Page>
  </CrbMonitorListContextProvider>
)
